class AccountModal extends HTMLElement {
  constructor() {
    super();
    this.closeBtn = this.querySelector("#closeModal");
    this.switchBtns = this.querySelectorAll(".form-switcher");
    this.accountForms = this.querySelectorAll(".modal-body__form-container form .submit-btn");
    this.completeMessage = this.querySelector(".modal-complete-message");
    this.mainContents = this.querySelector(".modal-maincontents");
    this.modalMessage = this.querySelector(".modal-complete-message #modal-message");
    this.continueShopping = this.querySelector(".modal-complete-message .continue-shopping");
    this.openForm = localStorage.getItem("form-opened");

    this.addEventListener("click", this.clickBackground.bind(this));
    this.closeBtn && this.closeBtn.addEventListener("click", this.closeModal.bind(this));
    this.continueShopping.addEventListener("click", this.closeModal.bind(this));

    this.switchBtns.forEach((switchBtn) => {
      switchBtn.addEventListener("click", this.switchFormClick.bind(this));
    });

    this.accountForms.forEach((form) => {
      form.addEventListener("click", this.formSubmit.bind(this));
    });

    document.getElementById("CustomerEmail").value = localStorage.getItem("signInEmail");
    document.getElementById("RegisterForm-email").value = localStorage.getItem("signUpEmail");

    if(this.openForm && this.openForm === "opened" && window.location.pathname !== "/challenge") {
      this.openModal()
    }
  }

  openModal(event) {
    const currentForm = localStorage.getItem("current-form");

    if(currentForm) {
      const errorExists = this.querySelector(`.modal-body__form-container[data-form='${localStorage.getItem("current-form")}'] .field__error-msg`);
      if(!errorExists) {
        if(currentForm === "register")
          this.modalMessage.innerHTML = "Thank you for registering with us.";
        else if(currentForm === "signIn") {
          this.modalMessage.innerHTML = "You have successfully logged in.";
          // const loginBtn = document.querySelector(".link--login");
          // loginBtn ? loginBtn.classList.remove("link--login") : "";
        }
        else if(currentForm === "reset"){
          this.modalMessage.innerHTML = "If there is an account associated with the email you entered, you will receive an email with a link to reset your password.";
        }

        this.completeMessage.classList.add("message-active");
        this.mainContents.classList.remove("contents-active");
        this.classList.add("modal--open");
      } else {
        const currentBtn = this.querySelector(`.form-switcher[data-label='${localStorage.getItem("current-form")}']`);
        this.switchForm(currentBtn);
        this.completeMessage.classList.remove("message-active");
        this.mainContents.classList.add("contents-active");
        this.classList.add("modal--open");
      }
      if(currentForm === "reset"){
        document.querySelector('.modal-header .form-switcher--wrapper').style.display = 'none';
      }
      localStorage.setItem("form-opened", "");
      localStorage.setItem("current-form", "");
    }
  }

  formSubmit(event) {
    const currentForm = event.target.closest(".modal-body__form-container").dataset.form;
    localStorage.setItem("signInEmail", document.getElementById("CustomerEmail").value);
    localStorage.setItem("signUpEmail", document.getElementById("RegisterForm-email").value);
    localStorage.setItem("form-opened", "opened");
    localStorage.setItem("current-page", window.location.href);
    localStorage.setItem("current-form", currentForm);
  }

  switchFormClick(event) {
    const event_label = event.target.getAttribute('data-label');
    if(event_label == 'reset')
      document.querySelector('.modal-header .form-switcher--wrapper').style.display = 'none';
    if(event_label == 'signIn') 
      document.querySelector('.modal-header .form-switcher--wrapper').style.display = 'block';
    event.preventDefault();
    const currentBtn = event.target;
    this.switchForm(currentBtn);
  }

  switchForm(currentBtn) {
//     event.preventDefault();
//     const currentBtn = event.target;
    const activeBtn = this.querySelector(".form-switcher.formactive");

    const signInBtn = this.querySelector('.modal-header .form-switcher--wrapper .form-switcher[data-label="signIn"]');

    const currentForm = this.querySelector(`.modal-body__form-container[data-form='${currentBtn.dataset.label}']`);
    const activeForm = this.querySelector(`.modal-body__form-container[data-form='${activeBtn.dataset.label}']`);

    if(currentBtn && activeBtn) {
      if(currentBtn === activeBtn) return
      else {
        const currentBtnText = currentBtn.textContent.replace(/(\r\n|\n|\r)/gm, "").replace(/ /g, "").toLowerCase();
        
        activeBtn.classList.remove("formactive");
        if(currentBtnText == "backtologin") 
          signInBtn.classList.add("formactive");
        else
          currentBtn.classList.add("formactive");

        activeForm.classList.remove("form--open");
        currentForm.classList.add("form--open");
      }
    }
  }

  clickBackground(event) {
    const current_url = window.location.href;
    if(current_url.includes('/account/register') || current_url.includes('/account/login')) { return; }
    const currentItem = event.target;
    if(currentItem === this && currentItem.classList.contains("modal--open"))
      this.closeModal();
  }

  closeModal(event) {
    this.classList.remove("modal--open");
  }
}

customElements.define("account-modal", AccountModal);

const validateEmail = (email) => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};
function validateFormLogin(){
  removeElementsByClass('field__error-msg');
  var lights = document.getElementsByClassName("field__error");
  while (lights.length)
      lights[0].className = lights[0].className.replace(/\bfield__error\b/g, "");
  document.getElementById("CustomerEmail").classList.remove("failValidate");
  document.getElementById("CustomerPassword").classList.remove("failValidate");
  if(document.getElementById('CustomerEmail').value == '') {
    document.getElementById('CustomerEmail').classList.add('failValidate');
    document.getElementById('CustomerEmailLabel').innerHTML="This is a required field."
    return false;
  }
  if(!validateEmail(document.getElementById('CustomerEmail').value)) {
    document.getElementById('CustomerEmail').classList.add('failValidate');
    document.getElementById('CustomerEmailLabel').innerHTML="Please enter a valid email address.";
    return false;
  }
  if(document.getElementById('CustomerPassword').value == '') {
    document.getElementById('CustomerPassword').classList.add('failValidate');
    return false;
  }
  return true;
}
function validateFormLReset(){
  removeElementsByClass('field__error-msg');
  var lights = document.getElementsByClassName("field__error");
  while (lights.length)
      lights[0].className = lights[0].className.replace(/\bfield__error\b/g, "");
  document.getElementById("RecoverEmail").classList.remove("failValidate");
  if(document.getElementById('RecoverEmail').value == '') {
    document.getElementById('RecoverEmail').classList.add('failValidate');
    document.getElementById('CustomerResetLabel').innerHTML="This is a required field."
    return false;
  }
  if(!validateEmail(document.getElementById('RecoverEmail').value)) {
    document.getElementById('RecoverEmail').classList.add('failValidate');
    document.getElementById('CustomerResetLabel').innerHTML="Please enter a valid email address.";
    return false;
  }
  return true;
}
function validateFormSignUp(){
  removeElementsByClass('field__error-msg');
  var lights = document.getElementsByClassName("field__error");
  while (lights.length)
      lights[0].className = lights[0].className.replace(/\bfield__error\b/g, "");
  document.getElementById("RegisterForm-email").classList.remove("failValidate");
  document.getElementById("RegisterForm-password").classList.remove("failValidate");
  if(document.getElementById('RegisterForm-email').value == '') {
    document.getElementById('RegisterForm-email').classList.add('failValidate');
    document.getElementById('RegisterFormEmailLabel').innerHTML="This is a required field."
    return false;
  }
  if(!validateEmail(document.getElementById('RegisterForm-email').value)) {
    document.getElementById('RegisterForm-email').classList.add('failValidate');
    document.getElementById('RegisterFormEmailLabel').innerHTML="Please enter a valid email address.";
    return false;
  }
  if(document.getElementById('RegisterForm-password').value == '') {
    document.getElementById('RegisterForm-password').classList.add('failValidate');
    return false;
  }
  return true;
}
function removeElementsByClass(className){
    var elements = document.getElementsByClassName(className);
    while(elements.length > 0){
        elements[0].parentNode.removeChild(elements[0]);
    }
}
